import OnloadPopup from 'client/common/components/onload-popup';

import './OnloadPopup.css';

export default OnloadPopup;
